import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shiftDate'
})
export class ShiftDatePipe implements PipeTransform {
  private readonly periods = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];

  transform(value: any, skew: number, period: string): string {
    if (!value)
      throw new Error('Value required');
    if (!skew) 
      throw new Error('Time shift required');
    if (!period || !this.periods.some(v => v === period))
      throw new Error(`Time period must be one of the following: ${this.periods.join()}. Current value ${period}`);
    let d = new Date(value);
    let year = period === 'years' ? d.getFullYear() + skew : d.getFullYear();
    let month = period === 'months' ? d.getMonth() + skew : d.getMonth();
    let day = period === 'days' ? d.getDate() + skew : d.getDate();
    let hour = period === 'hours' ? d.getHours() + skew : d.getDate();
    let minute = period === 'minutes' ? d.getMinutes() + skew : d.getMinutes();
    let seconds = period === 'seconds' ? d.getSeconds() + skew : d.getSeconds();
    let c = new Date(year, month, day, hour, minute, seconds);
    return c.toDateString();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/shift-date.pipe.ts